/**
 * @type {angular}
 */
module.exports = window.angular;



//////////////////
// WEBPACK FOOTER
// ./angular.js
// module id = 11
// module chunks = 0